// extracted by mini-css-extract-plugin
export default {"dash__loader":"required-auth_dash__loader__c3cFc","dash__loadertext":"required-auth_dash__loadertext__5YZz6","dash__loader_spinner":"required-auth_dash__loader_spinner__F5B2Z"};